import {
    createStore,
    applyMiddleware,
    compose,
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {
    logger,
} from 'redux-logger';
import makeReducer from './reducers';

function makeMiddleware({sagaMiddleware}) {
    if (process.env.NODE_ENV === 'development') {
        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        /*
        const composeEnhancers = composeWithDevtools({
            name: 'EditorApp',
        });
        */
        return composeEnhancers(
            applyMiddleware(
                sagaMiddleware,
                logger,
            ),
        );
    }
    return applyMiddleware(
        sagaMiddleware,
    );
}

export default function makeStore(rootSaga) {
    const initialState = {};
    const sagaMiddleware = createSagaMiddleware();
    const middlewares = makeMiddleware({
        sagaMiddleware,
    });
    const store = createStore(
        makeReducer,
        initialState,
        middlewares,
    );
    sagaMiddleware.run(rootSaga);
    return store;
}
